'use client'

import { HeaderBase } from './HeaderBase'
import { useTranslation } from '@/i18n/client'
// import { useParams } from 'next/navigation'
import { usePathname } from 'next/navigation'

export function Header({ lng, path, toggleSidebar, isSidebarOpen }: { lng: string; path?: string; toggleSidebar?: () => void; isSidebarOpen?: boolean }) {
  const { i18n } = useTranslation(lng, 'header')
  const pathName = usePathname()
  return <HeaderBase i18n={i18n} lng={lng} path={pathName} toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
}

// if you like to avoid prop drilling, you can do so with useParams()
// export function Footer({ path }: {
//   path: string;
// }) {
//   const params = useParams<{ lng: string; }>()
//   const { i18n } = useTranslation(params.lng, 'footer')
//   return <FooterBase i18n={i18n} lng={params.lng} path={path} />
// }
